export const SORT_PATH_ROUTES = {
    sortPathGridAllocation: {
        path: "/sort-paths"
    },
    uploadedSortPaths: {
        path: "/sort-paths/uploadedPaths"
    },
};
